// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.rule-line[data-v-33dbc862] { font-size: 12px; line-height: 1.6;\n}\n.formula[data-v-33dbc862] { color: #909399;\n}\n", ""]);
// Exports
module.exports = exports;
